import { DateTimeFormat, formatDateTime } from '@occc-app/lib/date';

export const tickMonthAndDateSlashedFormatter = (time: number) => {
  return formatDateTime(new Date(time), DateTimeFormat.MonthAndDateSlashed);
};
